export const CompPerm = {
	is_also_transporter: 1,
    is_output_document: 2
}